import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';
import numeral from 'numeral';
import uniq from 'lodash.uniq';

import MeasurementTypes from '../../../../models/measurement-types.json';
import FullscreenToggle from '../components/FullscreenToggle';
import { Panel } from '../../../../components';
import { short } from '../../common/formatting/date';

const SUPPORTED_TYPES = MeasurementTypes.map(({ value }) => value);

const Vitals = ({ patientId, onExpand, onContract, isDependentEvisit = false, }) => {
	const [{ data: rawVitals, loading, /* error */ }, getVitals] = useAxios(`/patients/${patientId}/vitals`, { manual: true });

	useEffect(() => {
		if (!isDependentEvisit) {
			getVitals();
		}
	}, [isDependentEvisit]);

	const groupedData = [];
	if (rawVitals && Array.isArray(rawVitals)) {
		const preparedVitals = [];
		let measurementDetails;
		rawVitals.forEach(function(vital) {
			let values;
			const preparedValue = [];
			if (SUPPORTED_TYPES.indexOf(vital.name) >= 0) {
				measurementDetails = MeasurementTypes.find(({ value }) => value === vital.name);
				vital.label = measurementDetails.label;
				values = vital.value.split('|');
				for (let i = 0; i < measurementDetails.fields.length; i++) {
					if (measurementDetails.fields[i].format) {
						preparedValue.push(numeral(values[i]).format(measurementDetails.fields[i].format));
					} else {
						preparedValue.push(values[i]);
					}
					if (measurementDetails.fields[i].suffix) {
						preparedValue.push(measurementDetails.fields[i].suffix);
					}
				}
				vital.preparedValue = preparedValue.length > 0 ? preparedValue.join(' ') : vital.value;
				preparedVitals.push(vital);
			}
		});

		const groups = uniq(preparedVitals.map(({ name }) => name));
		groups.forEach((group) => {
			const groupDetails = {
				data: []
			};
			const groupData = preparedVitals.filter(({ name }) => name === group).reverse().slice(0, 5);
			const values = [], values2 = [];
			groupDetails.label = groupData[0].label;
			groupDetails.currentValue = groupData[0].preparedValue;
			groupData.forEach((model) => {
				const value = model.value;
				const pipedValues = [];
				groupDetails.data.push(model);

				value.split('|').forEach(function(pv) {
					const parsedVal = parseInt(pv, 10);
					if (!isNaN(parsedVal)) {
						pipedValues.push(parsedVal);
					}
				});
				if (pipedValues.length === 1) {
					values.push(pipedValues[0]);
				} else {
					values.push(pipedValues[0]);
					values2.push(pipedValues[1]);
				}
			});
			// if (group !== 'height' && values.length > 1) {
			// 	groupDetails.sparkData1 = values;
			// 	if (values2.length) {
			// 		groupDetails.sparkData2 = values2;
			// 	}
			// });
			groupedData.push(groupDetails);
		});
	}

	return (
		<div>
			<FullscreenToggle onExpand={onExpand} onContract={onContract} />
			{loading && (
				<div colSpan={5}>Loading...</div>
			)}
			<div className="row">
				{groupedData.map((group) => (
					<div key={group.label} className="col-md-6">
						<Panel
							label={group.label}
							headerExtras={(
								<div className="pull-right">{group.currentValue}</div>
							)}
						>
							<table className="table table-striped">
								<tbody>
									{group.data.map((vital) => (
										<tr key={`${vital.name}-${vital.id}`}>
											<td>{vital.preparedValue}</td>
											<td>{short(vital.vital_dttm)}</td>
											<td>
												{vital.data_source && (
													<React.Fragment>
														{vital.data_source} {vital.update_dttm ? `(${short(vital.update_dttm)})` : ''}
													</React.Fragment>
												)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</Panel>
					</div>
				))}
			</div>
		</div>
	);
};

Vitals.propTypes = {
	patientId: PropTypes.number.isRequired,
	onExpand: PropTypes.func.isRequired,
	onContract: PropTypes.func.isRequired,
	isDependentEvisit: PropTypes.bool,
};

export default Vitals;
